export default {
  showMobileMenu: false,
  currentScenes: [],
  changing: false,
  availableSectors: [],
  currentSectors: [],
  url: window.location.protocol + '//' + window.location.hostname.replace(':8081', '')
}



// WEBPACK FOOTER //
// ./src/vuex/state.js